var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#064E72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#064E72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79366 14.4644V13.9612C9.31839 13.9526 9.70118 13.8795 9.94204 13.7419C10.1915 13.6042 10.3162 13.3419 10.3162 12.9548V10.0902C10.3162 9.68594 10.2732 9.38486 10.1872 9.18701C10.1012 8.98916 9.94204 8.86013 9.70978 8.79992C9.47753 8.7311 9.13774 8.69669 8.69043 8.69669V8.19347C9.45602 8.17626 10.084 8.12035 10.5743 8.02572C11.0732 7.9225 11.5119 7.75906 11.8904 7.5354V12.9806C11.8904 13.3505 11.9937 13.6042 12.2001 13.7419C12.4066 13.8795 12.7765 13.9526 13.3098 13.9612V14.4644C13.0947 14.4558 12.7808 14.4472 12.3678 14.4386C11.9635 14.4214 11.5549 14.4128 11.142 14.4128C10.6861 14.4128 10.2388 14.4214 9.80011 14.4386C9.3614 14.4472 9.02591 14.4558 8.79366 14.4644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.2f9d5e1e.svg";
export { ForwardRef as ReactComponent };